module.exports = __webpack_public_path__ + "static/media/image_44.f0ed20bd.png";